import Session from '../auth/Session';
import { authFetch, SessionExpiredError } from './apiClient';

/**
 * registerFromQuote
 * Creates a new user account during the signup flow.
 * Returns { success, accountExists, tempPassword, errorMessage }
 */
export async function registerFromQuote({ email, firstName, lastName, phone }) {
    const response = await fetch('api/Account/RegisterFromQuote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            Email: email,
            FirstName: firstName,
            LastName: lastName,
            Phone: phone,
        }),
    });

    if (!response.ok) {
        throw new Error(`RegisterFromQuote failed: ${response.status}`);
    }

    return response.json();
    // Returns: { success: bool, accountExists: bool, tempPassword: string, errorMessage: string }
}

/**
 * autoLogin
 * Logs the user in immediately after account creation using their temp password.
 * Calls the existing token endpoint and sets the session.
 * Returns true on success, false on failure.
 */
export async function autoLogin(email, tempPassword) {
    const response = await fetch('api/Account/token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ Username: email, Password: tempPassword }),
    });

    if (!response.ok) return false;

    const tokenData = await response.json();
    if (!tokenData?.token) return false;

    Session.setUserSession(
        tokenData.userName,
        tokenData.token,
        tokenData.userId,
        tokenData.userRoles
    );

    return true;
}

/**
 * updatePassword
 * Replaces the temp password with the user's chosen password.
 * Called from FinalizePolicy. User must be authenticated.
 */
export async function updatePassword(newPassword) {
    const response = await authFetch('api/Account/UpdatePassword', {
        method: 'PUT',
        body: JSON.stringify({ NewPassword: newPassword }),
    });

    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.errorMessage || `UpdatePassword failed: ${response.status}`);
    }

    return response.json();
}